import service from '@/utils/request'
// 获取入库管理订单列表
export function getWmsOrderList(param) {
	return service.request({
		method: 'POST',
		url: '/app/wmsOrder/wmsOrderList',
		data: param
	})
}
// 获取入库单信息
export function getWmsOrderById(param) {
	return service.request({
		method: 'POST',
		url: '/app/wmsOrder/wmsOrderById',
		data: param
	})
}
// 获取入库单明细列表
export function getWmsOrderMxList(param) {
	return service.request({
		method: 'POST',
		url: '/app/wmsOrderMx/wmsOrderMxList',
		data: param
	})
}

